import * as $ from "jquery";

export default class DeliveryAddressComponent {
    constructor() {
        this.modalSelector = '#customerDetailsModal .modal-content';
        this.onClose = null;
        this.showRadioButtons = false;
    }

    init() {
        let instance = this;
        instance.bind();
    }

    bind() {
        let instance = this;

        $(document).off('click', '.js-edit-address').on('click', '.js-edit-address', function () {
            const addressId = $(this).attr('data-addressid');
            const customerId = $(this).attr('data-customerid');

            const customerNumber = $(this).closest('.address-card__actions').attr('data-customer');
            const marketId = $(this).closest('.address-card__actions').attr('data-marketid');
            instance.openEditModal(customerNumber, marketId, addressId, customerId);
        });

        $(document).off('click', '.js-add-address').on('click', '.js-add-address', function () {
            const customerNumber = $(this).attr('data-customer');
            const marketId = $(this).attr('data-marketid');
            const customerId = $(this).attr('data-customerid');

            instance.openEditModal(customerNumber, marketId, null, customerId);
        });

        $(document).off('click', '.js-set-default-address').on('click', '.js-set-default-address', function () {
            const addressId = $(this).parent().attr('data-addressId');
            const customerNumber = $(this).parent().attr('data-customer');
            const marketId = $(this).parent().attr('data-marketid');
            instance.setDefaultAddress(addressId, customerNumber, marketId, instance);
        });

        $(document).off('click', '.js-delete-address').on('click', '.js-delete-address', function (e) {
            e.preventDefault();
            const addressId = $(this).attr('data-addressid');
            const customerNumber = $(this).closest('.address-card__actions').attr('data-customer');
            const marketId = $(this).closest('.address-card__actions').attr('data-marketid');
            instance.deleteAddress(addressId, customerNumber, marketId, instance);
        });

        $(document).off('click', '.js-save-edit-address').on('click', '.js-save-edit-address', function () {
            const $btn = $(this);
            $btn.prop('disabled', true).text('');
            $btn.append('<span class="save-spinner"></span>');
            instance.saveAddress(instance);
        });

        $(document).on('change', 'input[name="shipping-address"]', function () {
            $('input[name="shipping-address"]').removeAttr('checked');
            $(this).attr('checked', 'checked');
        });
    }

    loadAddressModal(customerNumber, marketId, showRadioButtons = null) {
        let instance = this;
        this.currentCustomerNumber = customerNumber;
        this.currentMarketId = marketId;
        const useRadioButtons = showRadioButtons !== null ? showRadioButtons : this.showRadioButtons;

        $.get("/address/AddressModal", {customerNumber: customerNumber, marketId: marketId, showRadioButtons: useRadioButtons}, function (html) {
            $(instance.modalSelector).html(html);
        });
    }

    openEditModal(customerNumber, marketId, addressId, customerId) {
        let instance = this;
        this.currentCustomerNumber = customerNumber;
        this.currentMarketId = marketId;
        this.editOpenedFromAddressModal = !!addressId;

        if (!this.customerDetailsContent) {
            this.customerDetailsContent = $(this.modalSelector).html();
        }

        const params = { customerNumber: customerNumber, marketId: marketId, customerId: customerId };
        if (addressId) params.addressId = addressId;
        $.get("/address/EditAddressModal", params, function (html) {
            if (!$(instance.modalSelector).attr('data-previous-content')) {
                $(instance.modalSelector).attr('data-previous-content', $(instance.modalSelector).html());
            }
            $(instance.modalSelector).html(html);
        });
    }

    setDefaultAddress(addressId, customerNumber, marketId, instance) {
        axios({
            method: 'post',
            url: "/address/SetAsDefaultAddress",
            data: { addressId: addressId, customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            if (response.data) {
                instance.loadAddressModal(customerNumber, marketId);
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    deleteAddress(addressId, customerNumber, marketId, instance) {
        axios({
            method: 'post',
            url: "/address/DeleteAddress",
            data: { addressId: addressId, customerNumber: customerNumber, marketId: marketId }
        }).then(function (response) {
            if (response.data) {
                instance.loadAddressModal(customerNumber, marketId);
            }
        }).catch(function (response) {
            console.log(response);
        });
    }

    saveAddress(instance) {
        const addressId = $('#edit-address-id').val();
        const isNew = !addressId;
        const customerNumber = $('#edit-customer-number').val();
        const customerId = $('#edit-customer-id').val();
        const marketId = $('#edit-market-id').val();

        const data = {
            id: addressId || 0,
            contact: $('#edit-contact').val(),
            saloonName: $('#edit-saloon-name').val(),
            phone: $('#edit-phone').val(),
            address1: $('#edit-address1').val(),
            zip: $('#edit-zip').val(),
            city: $('#edit-city').val(),
            country: $('#edit-country').val(),
            isDefaultAddress: document.getElementById('edit-is-default') ? document.getElementById('edit-is-default').checked : false,
            customerNumber: customerNumber,
            customerId: customerId,
            marketId: parseInt(marketId)
        };

        const url = isNew ? "/address/CreateAddress" : "/address/UpdateAddress";

        axios({
            method: 'post',
            url: url,
            data: data
        }).then(function (response) {
            if (response.data) {
                if (instance.editOpenedFromAddressModal) {
                    instance.editOpenedFromAddressModal = false;
                    instance.loadAddressModal(
                        instance.currentCustomerNumber,
                        instance.currentMarketId
                    );
                } else {
                    $(instance.modalSelector).attr('data-previous-content', null);
                    instance.loadAddressModal(
                        instance.currentCustomerNumber,
                        instance.currentMarketId, true
                    );
                }
            }
        }).catch(function (response) {
            console.log(response);
        });
    }
}